import { render } from "./LotteryDetail.vue?vue&type=template&id=746e65d3&scoped=true"
import script from "./LotteryDetail.vue?vue&type=script&lang=js"
export * from "./LotteryDetail.vue?vue&type=script&lang=js"

import "./LotteryDetail.vue?vue&type=style&index=0&id=746e65d3&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746e65d3"]])

export default __exports__